import { createSlice } from "@reduxjs/toolkit";
import { FipState } from "./fip.types";
import { searchFipThunk, fetchFiCategoriesThunk } from "./fipThunk";
const initialState: FipState = {
    loading: false,
    fips: [],
    categories: [],
};

const fipSlice = createSlice({
    name: "fip",
    initialState,
    reducers: {
        selectFip(state, action) {
            state.selectedFip = action.payload;
        },
        setSelectedCategory(state, action) {
            state.selectedCategoryId = action.payload;
        },
        resetFip: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchFiCategoriesThunk.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchFiCategoriesThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.categories = action.payload || [];
            })
            .addCase(fetchFiCategoriesThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(searchFipThunk.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(searchFipThunk.fulfilled, (state, action) => {
                state.loading = false;
                // Map raw API response (lst) to internal Fip interface
                const rawList = action.payload.lst || [];
                // Use base logo url requested by user
                const baseLogoUrl = "https://uat.camsfinserv.com/newuat/assets/images/banks/";

                state.fips = rawList.map(item => {
                    let assetName = item.LOGO || "";
                    // Extract just the filename if the API returns a full path
                    if (assetName.includes('/')) {
                        assetName = assetName.split('/').pop() || assetName;
                    }
                    return {
                        FIP_ID: item.FIPID,
                        FIP_NAME: item.FIPNAME,
                        LOGO_URL: assetName ? `${baseLogoUrl}${assetName}` : "",
                        FI_TYPES: [] // Default as not present in this response
                    };
                });
            })
            .addCase(searchFipThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const { selectFip, setSelectedCategory, resetFip } = fipSlice.actions;
export default fipSlice.reducer;
